import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import FavStarFillIcon from '@wix/da-ds/pkg/Icons/16x16/FavStarFill';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextTooltipOnHover from '../../../../Popover/Preset/TextTooltipOnHover';
import s from './FavouritesLabel.scss';
const FavouritesLabel = ({ className, tooltipUser })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const tooltipText = tooltipUser && t('common.favourites_tooltip', {
        username: tooltipUser.username
    });
    const label = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FavStarFillIcon, {
        className: s['icon'],
        disableDefaultColors: true,
        size: IconSize.TINY
    }), ' ', t('common.favourites_other'));
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, !isMobile && tooltipText ? /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
        tooltipText: tooltipText
    }, label) : label);
};
FavouritesLabel.displayName = 'FavouritesLabel';
export default FavouritesLabel;
